export const clfValueFields = [{
        name: "code",
        title: "Codice"
    }, {
        name: "displayOrder",
        title: "Ordine"
    }, {
        name: "description",
        title: "Descrizione"
    }];
